import React, { useEffect, useRef, useState } from 'react';
import './ProgressiveDisclosure.css';

const ExpandableContent = ({
  children,
  maxHeight = 160,
  showMoreText = 'Show more',
  showLessText = 'Show less',
  className = '',
  buttonClassName = 'expandable-content__toggle',
  buttonStyle = {},
}) => {
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const measure = () => {
      const node = contentRef.current;
      if (node) {
        setOverflowing(node.scrollHeight > maxHeight + 4);
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [children, maxHeight]);

  return (
    <div className={`expandable-content ${expanded ? 'expandable-content--expanded' : 'expandable-content--collapsed'} ${className}`}>
      <div
        ref={contentRef}
        className="expandable-content__body"
        style={{ maxHeight: expanded || !overflowing ? 'none' : `${maxHeight}px` }}
      >
        {children}
      </div>
      {overflowing && (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <button type="button" className={buttonClassName} style={buttonStyle} onClick={() => setExpanded((value) => !value)}>
            {expanded ? showLessText : showMoreText}
          </button>
        </div>
      )}
    </div>
  );
};

export default ExpandableContent;

